export interface DocumentTemplate {
  id: number;
  templateKey: string;
  name: string;
  category: DocumentCategory;
  sharePointTemplateId: string;
  description?: string;
  availablePlaceholders: string[];
  requiredContext: RequiredContext[];
  isActive: boolean;
  legacyEndpoint?: string;
  metadata?: Record<string, any>;
  createdAt: string;
  updatedAt: string;
}

export enum DocumentCategory {
  ACQUISITION = 'ACQUISITION',
  CONTRACT = 'CONTRACT',
  INSPECTION = 'INSPECTION',
  LEGAL = 'LEGAL',
  RENOVATION = 'RENOVATION',
  GENERAL = 'GENERAL'
}

export enum RequiredContext {
  UNIT_ID = 'unitId',
  CONTRACT_ID = 'contractId',
  ACQUISITION_ID = 'acquisitionId',
  BUILDING_ID = 'buildingId',
  CONTACT_ID = 'contactId',
  COMPANY_ID = 'companyId'
}

export interface CreateDocumentTemplateDto {
  templateKey: string;
  name: string;
  category: DocumentCategory;
  sharePointTemplateId: string;
  description?: string;
  availablePlaceholders: string[];
  requiredContext: RequiredContext[];
  legacyEndpoint?: string;
  metadata?: Record<string, any>;
}

export interface PlaceholderInfo {
  key: string;
  label: string;
  description: string;
  example: string;
  category: 'tenant' | 'unit' | 'building' | 'contract' | 'company' | 'dates' | 'financial' | 'meters' | 'devices';
  dataPath?: string;
}

export interface DocumentTypeDefinition {
  category: DocumentCategory;
  name: string;
  description: string;
  placeholders: PlaceholderInfo[];
  requiredEntities: string[];
}

export interface PlaceholderValidation {
  valid: boolean;
  foundPlaceholders: string[];
  missingPlaceholders: string[];
}

export interface ExtractedPlaceholder {
  placeholder: string;
  entity?: string;
  property?: string;
  relationPath?: string[]; // e.g., ["building"] from "unit.building.address"
  isValid: boolean;
  errorMessage?: string;
  isDynamicValue?: boolean;
  dynamicValueKey?: string;
}

export interface DocxAnalysisResult {
  placeholders: ExtractedPlaceholder[];
  validPlaceholders: ExtractedPlaceholder[];
  invalidPlaceholders: ExtractedPlaceholder[];
  dynamicValuePlaceholders?: ExtractedPlaceholder[]; // waarde.* placeholders
  entityMap: Record<string, string[]>; // entity -> properties[]
  dynamicValueKeys?: string[]; // List of dynamic value keys
}

export interface EntityProperty {
  key: string;
  description: string;
  example: string;
}

export interface EntityInfo {
  name: string;
  description: string;
  properties: EntityProperty[];
}

export interface UploadAnalysisResult {
  fileId: string;
  fileUrl: string;
  fileName: string;
  analysis: DocxAnalysisResult;
  entityInfo: Record<string, EntityInfo>;
}
